<template>
  <sui-segment>
	<!-- <v-btn @click.prevent="handleClickAdd">Add</v-btn> -->
    <DataTable :key="updateTable"
              uri="category"
              searchable
              long
			  create
              :options="tableOptions"
			  v-on:clickCreate="handleClickAdd"
			  v-on:clickEdit="handleClickEdit"
              v-on:clickRow="callbackClickRow"
              v-on:clickRemove="callbackClickRemove" />

	<sui-modal v-model="showModal">
      <sui-modal-header>{{$t(mode+"Category") }}</sui-modal-header>
      <sui-modal-content  scrolling>
        <sui-modal-description>
            
             <v-text-field 
             :label="$t('name')"
             v-model="current.name"></v-text-field>
			 <v-row>
				 <v-col cols="12" md=6>
             <v-color-picker
			 v-model="current.color"
			 elevation="15"
			></v-color-picker></v-col>
				 <v-col cols="12" md=6>
              <v-select
                :items='groupDropdown'
                item-value="key"
                item-text="value"
                :label="$t('groups')"
				multiple
                v-model="current.groups"></v-select>
			</v-col>
			</v-row>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click.native="handleSave">
          {{$t('save')}}
        </sui-button>
      </sui-modal-actions>
    </sui-modal>


  </sui-segment>
</template>

<script>

import DataTable from '@/components/DataTable.vue';
import ApiService from "@/services/ApiService.js"
export default {
  components: {
    DataTable
  },
  name: 'Groups',
  data(){
    return {
        updateTable: 0,
        tableOptions: {
          columns: [
            {label: this.$t('name'), name: 'name' },
             {label: this.$t('createdAt'), name: 'created_at', time:true },
             {label: this.$t('color'), name: 'color' },
             {label: this.$t('groups'), name: 'groups' },
			{label: this.$t("actions"), name: "actions", sortable: false}
          ],
          search: '',
          start: 0,
          limit: 10,
          sortKey: 'id',
          sortAs: "asc",
        },
		current: {},
		showModal: false,
		groupDropdown: [],
		mode: "create",
		noClick: false
    }
  },
  async created(){
	  let res = await ApiService.getGroupDropdown();
        for(let [key, value] of Object.entries(res.data)){
			this.groupDropdown.push({key:key, value:value})
		}
  },
  methods: {
	  async handleClickAdd(){
		  this.current = {}
		  this.mode = "create"
		  this.current.color = this.randomColor()
		  this.showModal = true;
	  },
	  async callbackClickRow(row){
		  if(this.noClick==false){
		  	this.$router.push("/management/category/"+row.id)
		}
	  },
	   randomColor() {
		let color = '#';
		for (let i = 0; i < 6; i++){
			const random = Math.random();
			const bit = (random * 16) | 0;
			color += (bit).toString(16);
			}
		return color;
		},
	  async handleClickEdit(row){
		  this.$router.push("/management/category/"+row.id+"?edit=true")
	  },
	  async handleSave(){
		  typeof this.current.color != "string" ? this.current.color = this.current.color.hex : ""
		  if(this.mode == "create"){
			  this.showModal = false
		  let res = await ApiService.postCategory(this.current)
		  if(res.status == 201){
			  this.updateTable++
			  this.$swal({
				  icon: "success",
				  title: this.$t("success"),
				  text: this.$t("created")
			  })
			  this.current = {}
		  }else{
			  this.$swal({
				  icon: "error",
				  title: this.$t("error"),
				  text: this.$t(res.data.message || res.data)
			  })
		  }
		  }else{
			  this.showModal = false
			  let res = await ApiService.putCategory(this.current.id, {name: this.current.name, color: this.current.color, groups: this.current.groups})
		  if(res.status == 200){
			  this.updateTable++
			  this.$swal({
				  icon: "success",
				  title: this.$t("success"),
				  text: this.$t("edited")
			  })
			  this.current = {}
		  }else{
			  this.$swal({
				  icon: "error",
				  title: this.$t("error"),
				  text: this.$t(res.data.message || res.data)
			  })
		  }
		  }
	  },
	  async callbackClickRemove(row){
		  this.noClick = true;
		  let self = this
		this.$swal.fire({
			icon: "warning",
			title: this.$t("areYouSure"),
			text: this.$t("youCantRevert"),
			showCancelButton: false,
			showDenyButton: true,
			confirmButtonText: this.$t('yesDelete'),
			denyButtonText: this.$t("noKeep")
			}).then(async(result) => {
				self.noClick = false
			if (result.isConfirmed) {
				let res = await ApiService.deleteCategory(row.id);
				if (res===false) {
			  		this.updateTable++
					  this.$swal({
						  icon: "success",
						  title: this.$t("deleted"),
						  text: this.$t("deleteSuccess")
					  })
				}
			}
		})
	  }
  }
}
</script>
